import { transformCdnImageUrl } from "seneca-common/utils/images";

import { ImageAssetParameters, WordfillContentSource } from "../types";

export function getModuleAssets(source: WordfillContentSource): Array<string> {
  return source.imageURL ? [source.imageURL] : [];
}

export function transformModuleAssets(
  source: WordfillContentSource,
  assetParams: ImageAssetParameters
): WordfillContentSource {
  if (source.imageURL) {
    return {
      ...source,
      imageURL: transformCdnImageUrl(source.imageURL, assetParams.default)
    };
  }

  return source;
}
